import { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { useEditorStore } from '@/stores/editorStore';
import { EditorToolbar } from './EditorToolbar';

export function QuillEditor() {
  const editorRef = useRef<HTMLDivElement>(null);
  const setQuillInstance = useEditorStore((s) => s.setQuillInstance);
  // We use a ref to track if instance is created to avoid double initialization in React Strict Mode
  const quillRef = useRef<Quill | null>(null);

  useEffect(() => {
    if (editorRef.current && !quillRef.current) {
      const quill = new Quill(editorRef.current, {
        theme: 'snow',
        modules: {
          toolbar: {
            container: '#custom-toolbar',
          },
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: true,
          },
          keyboard: {
            bindings: {
              // We can add custom bindings here if needed, 
              // but standard bold/italic are handled by Quill
            }
          }
        },
        placeholder: 'Start writing your LinkedIn post...',
      });

      quillRef.current = quill;
      setQuillInstance(quill);
    }

    // Cleanup not strictly necessary for singleton-like usage in this app,
    // but good practice. However, destroying Quill might remove the toolbar bindings.
    // Since we mount once, we can leave it.
    
    return () => {
       // if we want to cleanup: quillRef.current = null;
    };
  }, [setQuillInstance]);

  return (
    <div className="flex flex-col h-full bg-card rounded-xl shadow-sm border border-border overflow-hidden">
      <EditorToolbar />
      <div ref={editorRef} className="flex-1 text-base text-text-primary" style={{ minHeight: '300px' }} />
    </div>
  );
}
